/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index copy-on-click to autogenerate all the components and extensions
 * Used by "prepareCopyOnClicks"
 */

import CopyOnClick from './copy-on-click/CopyOnClick'
export * from './copy-on-click/CopyOnClick'
export default CopyOnClick
